import { headerWithCtas } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  ${headerWithCtas.fragment('headerContent')}
`

export const fragment = (name = 'richTextHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
